/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { User } from './user';
import { SimpleInvestmentCompany } from './simple-investment-company';
import { DeckCreateInvestmentPaymentOption } from './deck-create-investment-payment-option';
import { InvestmentStatusEnum } from './investment-status-enum';
import { PaymentSlip } from './payment-slip';

export interface DeckInvestments {
  readonly id: string;
  readonly user: User;
  readonly investment_company: SimpleInvestmentCompany;
  payment_option: DeckCreateInvestmentPaymentOption | null;
  readonly amount: string | null;
  readonly status: InvestmentStatusEnum;
  readonly pitch_id: string;
  readonly pitch_name: string;
  /**
   * Auto Added Creation date
   */
  readonly created_date: string;
  readonly account_number: string | null;
  readonly vps: string | null;
  readonly agreement_url: string;
  readonly paid: boolean;
  readonly shares: number | null;
  readonly declared_shares: number | null;
  readonly payment_slip: PaymentSlip;
  readonly invested_by: User;
  readonly compensation: string | null;
  readonly agreement_idfy_id: string | null;
}
export namespace DeckInvestments {}
